/**
 * @flow
 * @relayHash 4ba4610be412d10210fe9feac2a08d44
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type app_query$ref = any;
export type srcAppQueryVariables = {||};
export type srcAppQueryResponse = {|
  +$fragmentRefs: app_query$ref
|};
export type srcAppQuery = {|
  variables: srcAppQueryVariables,
  response: srcAppQueryResponse,
|};
*/


/*
query srcAppQuery {
  ...app_query
}

fragment app_query on Query {
  cities {
    slug
    name
    availability
  }
  stores {
    slug
    name
  }
  categories {
    slug
    name
    availability
  }
  footer {
    ...footer_footer
  }
}

fragment footer_footer on Footer {
  facebookLink
  twitterLink
  instagramLink
  linkedinLink
  youtubeLink
  leftColumn {
    title
    link {
      id
      uid
      type
      slug
      link_type
      url
      target
    }
  }
  rightColumn {
    title
    link {
      id
      uid
      type
      slug
      link_type
      url
      target
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v2 = [
  v0,
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "availability",
    "args": null,
    "storageKey": null
  }
],
v3 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "title",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "link",
    "storageKey": null,
    "args": null,
    "concreteType": "Link",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "uid",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "type",
        "args": null,
        "storageKey": null
      },
      v0,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "link_type",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "url",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "target",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "srcAppQuery",
  "id": null,
  "text": "query srcAppQuery {\n  ...app_query\n}\n\nfragment app_query on Query {\n  cities {\n    slug\n    name\n    availability\n  }\n  stores {\n    slug\n    name\n  }\n  categories {\n    slug\n    name\n    availability\n  }\n  footer {\n    ...footer_footer\n  }\n}\n\nfragment footer_footer on Footer {\n  facebookLink\n  twitterLink\n  instagramLink\n  linkedinLink\n  youtubeLink\n  leftColumn {\n    title\n    link {\n      id\n      uid\n      type\n      slug\n      link_type\n      url\n      target\n    }\n  }\n  rightColumn {\n    title\n    link {\n      id\n      uid\n      type\n      slug\n      link_type\n      url\n      target\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "srcAppQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "app_query",
        "args": null
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "srcAppQuery",
    "argumentDefinitions": [],
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "cities",
        "storageKey": null,
        "args": null,
        "concreteType": "City",
        "plural": true,
        "selections": v2
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "stores",
        "storageKey": null,
        "args": null,
        "concreteType": "Store",
        "plural": true,
        "selections": [
          v0,
          v1
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "categories",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": true,
        "selections": v2
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "footer",
        "storageKey": null,
        "args": null,
        "concreteType": "Footer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "facebookLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "twitterLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "instagramLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "linkedinLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "youtubeLink",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "leftColumn",
            "storageKey": null,
            "args": null,
            "concreteType": "FooterItem",
            "plural": true,
            "selections": v3
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "rightColumn",
            "storageKey": null,
            "args": null,
            "concreteType": "FooterItem",
            "plural": true,
            "selections": v3
          }
        ]
      }
    ]
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4a6187777a32efb1a9a1187aec862b4b';
module.exports = node;
